import React from "react";
import { icons } from "@utils";
import { MainLayout } from "@containers/";

const NotFound = () => {
  return (
    <MainLayout>
      <icons.FaRegSadTear></icons.FaRegSadTear>
      404 Página no encontrada
    </MainLayout>
  );
};
export default NotFound;
